import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { moment } from './utils/date-shim'
import VueCookies from 'vue-cookies'
import titleMixin from './mixins/titleMixins'
import axios from './plugins/axios'

if (process.env.NODE_ENV === 'production') {
    console.log = function () {}
    console.debug = function () {}
    // console.warn = function () {}
    // console.error = function () {}
}

// If the browser restores this page from bfcache (back/forward button),
// no JS reruns, so the old logged-in UI would stay on screen.
// Reloading forces a fresh boot: no cookies -> redirected to login.
window.addEventListener('pageshow', event => {
    if (event.persisted) {
        window.location.reload()
    }
})

Vue.use(VueCookies)
Vue.prototype.moment = moment
Vue.config.productionTip = false
Vue.mixin(titleMixin)

// Call getCsrfToken before mounting
store
    .dispatch('getCsrfToken')
    .catch(() => {})
    .finally(() => {
        new Vue({ 
            router, 
            store, 
            vuetify, axios, render: h => h(App) }).$mount('#app')
    })
